/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Address } from './Address';
export type UpdateOwnClientPayload = {
    gender: UpdateOwnClientPayload.gender;
    firstName: string;
    lastName: string;
    phoneNumber: string | null;
    address: Address | null;
    birthdate: string | null;
};
export namespace UpdateOwnClientPayload {
    export enum gender {
        MALE = 'male',
        FEMALE = 'female',
        DIVERSE = 'diverse',
        NOT_SET = 'not_set',
        DELETED = 'deleted',
    }
}

